import * as tslib_1 from "tslib";
import { jsonMember } from "typedjson";
export class DxUserPrivilege {
    constructor(fields) {
        if (fields)
            Object.assign(this, fields);
    }
}
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxUserPrivilege.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserPrivilege.prototype, "name", void 0);
